import React from "react"
import { CardMembership } from "@material-ui/icons"

import ListCard from "../../../common/cards/ListCard"
import { ParticipantMemberTypeGrid } from "../../memberTypes/ParticipantMemberTypeGrid"

export default props => {
  return <ListCard
    title="resources.participantMemberTypes.labels.card.title"
    subtitle="resources.participantMemberTypes.labels.card.subtitle"
    icon={<CardMembership />}
    reference="participantMemberTypes"
    target="participants"
  >
    <ParticipantMemberTypeGrid />
  </ListCard>
}
